export function checkLocale(): boolean {
    /*********************************
****************
*****************************/
    return false;
}
